
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Taxiserviceinhinjewadipune() {



    const cardData =
    {
        keyword: 'Taxi Service in Hinjewadi Pune',
        heading: 'Platinum24 Cabs: Taxi Service in Hinjewadi Pune',
        headingDescription: ' Platinum24 Cabs offers dependable Taxi Service in Hinjewadi Pune, catering to IT professionals, corporate travelers, and residents of the area. Our fleet of hatchbacks, sedans, SUVs, and luxury cars provides safe, comfortable, and affordable travel for daily commutes, airport transfers, and outstation journeys. With professional chauffeurs, punctual pickups, and transparent fares, we ensure stress-free rides in one of Pune’s busiest IT hubs. Whether you need a quick city drop, client transfer, or weekend getaway, Platinum24 Cabs guarantees 24/7 availability, reliability, and comfort for taxi services in Hinjewadi.',

        top: 'Top Places to Visit in Pune with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas, Shaniwar Wada is Pune’s most iconic fort palace. Once the political seat of the Maratha Empire, it showcases grand gates, fountains, and gardens. Although partially destroyed by fire in 1828, its ruins still narrate tales of Bajirao and Mastani. The evening light-and-sound show brings history alive. Tourists love exploring its majestic corridors and courtyards. Shaniwar Wada is Pune’s proud heritage landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "The Aga Khan Palace, built in 1892, is a majestic monument with Indo-Italian architecture. It gained prominence during the freedom struggle as Mahatma Gandhi and Kasturba Gandhi were imprisoned here during the Quit India Movement. The palace now houses a museum with Gandhi’s personal items and photos. Surrounded by sprawling gardens, it offers peace and reflection. It is also a memorial to Kasturba Gandhi. Aga Khan Palace is Pune’s inspirational historic site."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, 25 km from Pune, is famous for the 1670 battle where Tanaji Malusare fought for Chhatrapati Shivaji Maharaj. The hill fort offers trekking trails with scenic views of the Sahyadris. Visitors explore bastions, temples, and memorials that echo Maratha valor. Monsoon makes it lush with mist and waterfalls. Local villagers serve traditional pithla-bhakri at the top. Sinhagad is Pune’s blend of history, trekking, and nature."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine, dedicated to Lord Ganesha. The magnificent idol is adorned with gold and precious ornaments. During Ganesh Chaturthi, the temple becomes the epicenter of grand festivities. It is also renowned for charitable and cultural activities. Devotees visit throughout the year for blessings. Dagdusheth Temple is Pune’s divine and cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Carved in the 8th century, Pataleshwar Cave Temple is a rock-cut shrine dedicated to Lord Shiva. The temple features huge stone pillars, a sanctum, and a Nandi mandapa. Located in the city center, it provides peace and spirituality amidst urban life. Its ancient carvings reflect early Indian craftsmanship. Evening prayers add to its mystical charm. Pataleshwar is Pune’s hidden spiritual heritage gem."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar. Exhibits include sculptures, ornaments, musical instruments, and daily-life antiques. The recreated Mastani Mahal is the museum’s highlight. Students, historians, and tourists find it educational and fascinating. It preserves centuries of Indian art and traditions. The museum is Pune’s cultural treasure trove."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers panoramic views of the city. The hilltop Parvati Temple is dedicated to Lord Shiva and Goddess Parvati, built during the Peshwa era. The climb of 103 steps is both devotional and adventurous. Smaller shrines and museums surround the main temple. Sunrise and sunset views are mesmerizing. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is a global hub for spirituality and wellness. Spread across lush gardens, it attracts visitors from all over the world. The ashram offers meditation, yoga, and personal growth workshops. Japanese Zen gardens and tranquil halls enhance the experience. It is ideal for peace, rejuvenation, and self-discovery. Osho Ashram is Pune’s international wellness destination."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. Flowing streams, stone bridges, and manicured lawns create a serene environment. Families enjoy peaceful strolls, picnics, and photography here. The garden represents Indo-Japanese friendship. Seasonal flowers make it colorful year-round. Pu La Deshpande Garden is Pune’s green oasis of calm and beauty."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend getaway near Pune. It supplies water to the city and offers picturesque views of hills and flowing waters. During monsoon, the overflowing dam is a spectacular sight. Vendors selling roasted corn and tea add to the charm. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural retreat."
  }
],



     "services": [
    {
      "name": "Taxi Service Hinjewadi Pune",
      "description": "Experience reliable and prompt taxi service in Hinjewadi Pune tailored for IT professionals, local residents, and business travelers. Our taxis are well-maintained, sanitized, and driven by courteous drivers who prioritize your safety and convenience. Whether for office commutes or personal errands, enjoy hassle-free rides around Hinjewadi and nearby areas."
    },
    {
      "name": "Hinjewadi Cab Service",
      "description": "Our Hinjewadi cab service offers flexible ride options including short city trips and long-distance travel. Equipped with GPS and well-trained drivers, the cabs ensure timely pickups and smooth navigation through the busy IT hub of Hinjewadi, giving you peace of mind for every journey."
    },
    {
      "name": "Taxi Booking in Hinjewadi Pune",
      "description": "Book your Hinjewadi taxi instantly via our online platform or phone booking service. Get real-time updates, fare estimates, and driver details immediately. Our hassle-free booking system guarantees your cab will arrive on time, making your daily commute or occasional travel seamless and stress-free."
    },
    {
      "name": "Local Cab Hinjewadi",
      "description": "Our local cab service in Hinjewadi is ideal for quick trips to nearby shopping centers, restaurants, and tech parks. Enjoy economical fares, well-maintained vehicles, and friendly drivers who understand the locality to get you to your destination efficiently."
    },
    {
      "name": "Hinjewadi Taxi Rentals",
      "description": "Rent a taxi in Hinjewadi for hourly or full-day use with flexible rental packages designed for your convenience. Perfect for business meetings, corporate events, or sightseeing tours in and around Hinjewadi, ensuring a comfortable and customized travel experience."
    },
    {
      "name": "Affordable Taxi Hinjewadi",
      "description": "Our Hinjewadi taxi services offer some of the most affordable rates in the city without compromising on quality. Transparent pricing policies ensure you know what you pay upfront, making it easy to manage your budget while enjoying reliable transportation."
    },
    {
      "name": "Hinjewadi Cab Hire",
      "description": "Hire a cab in Hinjewadi for short or extended periods with options ranging from economy to premium vehicles. Ideal for weddings, airport transfers, or personal travel, our cab hire service offers flexibility and professional drivers committed to delivering excellent service."
    },
    {
      "name": "Hinjewadi Taxi Booking Online",
      "description": "Easily book your Hinjewadi taxi online with instant confirmation, multiple payment options, and 24/7 customer support. The digital booking platform allows you to choose your preferred vehicle type and schedule rides in advance or on demand, ensuring convenience at your fingertips."
    },
    {
      "name": "Reliable Cab Service Hinjewadi",
      "description": "Count on our reliable cab service in Hinjewadi for punctual arrivals, courteous drivers, and safe rides. We prioritize customer satisfaction by maintaining high vehicle standards and providing responsive support throughout your journey, whether for daily commutes or special occasions."
    },
    {
      "name": "Hinjewadi Local Taxi",
      "description": "Our Hinjewadi local taxi service caters to short-distance travelers seeking quick and affordable rides. Perfect for last-minute trips, errands, or daily travel within the neighborhood, our cabs are ready to serve you anytime with comfort and safety."
    },
    {
      "name": "Hinjewadi Airport Taxi",
      "description": "Book seamless airport transfers between Hinjewadi and Pune Airport. Our airport taxi service offers timely pickups and drop-offs, with drivers tracking flight schedules to accommodate delays or early arrivals, ensuring a stress-free travel experience to and from the airport."
    },
    {
      "name": "Hinjewadi Outstation Taxi",
      "description": "Travel from Hinjewadi to nearby cities and popular destinations with our outstation taxi service. Choose from one-way or round-trip packages with experienced drivers and comfortable vehicles, providing you with a safe and relaxing journey beyond city limits."
    },
    {
      "name": "Hinjewadi Corporate Cab Service",
      "description": "Tailored corporate cab services in Hinjewadi support your company’s employee transport needs with dependable, punctual, and professional drivers. Benefit from customized billing, dedicated account management, and a modern fleet suitable for business travel and corporate events."
    },
    {
      "name": "Hinjewadi Night Taxi Service",
      "description": "Our night taxi service in Hinjewadi offers safe and reliable rides during late hours. With trained night-shift drivers, 24/7 availability, and real-time tracking, you can travel confidently at night for emergencies, late shifts, or social events."
    },
    {
      "name": "Hinjewadi Cab for Events",
      "description": "Plan your event transportation in Hinjewadi with our specialized cab services designed for weddings, corporate functions, parties, and more. We offer multi-vehicle bookings, fixed rates, and professional coordination to ensure smooth and timely guest transfers."
    }
  ],
  "tableData": [
    ["Taxi Service Hinjewadi Pune", "Hinjewadi Cab Service"],
    ["Taxi Booking in Hinjewadi Pune", "Local Cab Hinjewadi"],
    ["Hinjewadi Taxi Rentals", "Affordable Taxi Hinjewadi"],
    ["Hinjewadi Cab Hire", "Hinjewadi Taxi Booking Online"],
    ["Reliable Cab Service Hinjewadi", "Hinjewadi Local Taxi"],
    ["Hinjewadi Airport Taxi", "Hinjewadi Outstation Taxi"],
    ["Hinjewadi Corporate Cab Service", "Hinjewadi Night Taxi Service"],
    ["Hinjewadi Cab for Events", "—"]
  ],


          "whychoose": [
    {
      "WhyChooseheading": "Reliable Taxi Service in Hinjewadi, Pune",
      "WhyChoosedescription": "Platinum24 Cabs offers dependable taxi services in Hinjewadi, perfect for daily commutes and business travel."
    },
    {
      "WhyChooseheading": "Quick and Convenient Pickups Near Hinjewadi",
      "WhyChoosedescription": "Our taxis are stationed near Hinjewadi for fast and hassle-free pickups anytime."
    },
    {
      "WhyChooseheading": "Affordable Rates for Local and Outstation Trips",
      "WhyChoosedescription": "Enjoy competitive pricing for short rides within Pune or long-distance journeys."
    },
    {
      "WhyChooseheading": "Clean and Comfortable Vehicles with AC",
      "WhyChoosedescription": "Travel in sanitized, well-maintained taxis equipped with air conditioning for a comfortable ride."
    },
    {
      "WhyChooseheading": "Experienced Drivers Familiar with Hinjewadi Area",
      "WhyChoosedescription": "Our professional drivers have in-depth knowledge of Hinjewadi roads to ensure timely and safe travel."
    },
    {
      "WhyChooseheading": "24/7 Taxi Availability for Your Convenience",
      "WhyChoosedescription": "Book a taxi anytime with our round-the-clock service to meet your travel needs."
    },
    {
      "WhyChooseheading": "Flexible Booking Options for One-Way or Round Trips",
      "WhyChoosedescription": "Choose from customizable packages suitable for your itinerary."
    },
    {
      "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
      "WhyChoosedescription": "Receive upfront pricing that includes fuel, tolls, and driver allowances."
    }
  ]



























    }


const faqData = [
    {
        question: 'Does Platinum24 Cabs provide taxi services in Hinjewadi, Pune?',
        answer: 'Yes, Platinum24 Cabs offers reliable and convenient taxi services in Hinjewadi, Pune, catering to your local travel needs.',
    },
    {
        question: 'How can I book a taxi service in Hinjewadi with Platinum24 Cabs?',
        answer: 'You can easily book a taxi in Hinjewadi through our website, mobile app, or by contacting our customer support team.',
    },
    {
        question: 'What types of vehicles are available for taxi service in Hinjewadi?',
        answer: 'We provide a variety of vehicles including sedans, SUVs, and premium cars to suit your travel preferences and group size.',
    },
    {
        question: 'Are the drivers experienced for local travel within Hinjewadi?',
        answer: 'Yes, all our drivers are professional, experienced, and knowledgeable about the Hinjewadi area and routes.',
    },
    {
        question: 'Can I book a taxi for hourly or daily use in Hinjewadi?',
        answer: 'Absolutely! We offer flexible hourly and daily rental packages tailored to your schedule and travel requirements.',
    },
    {
        question: 'What is included in the fare for taxi services in Hinjewadi?',
        answer: 'The fare includes vehicle charges, driver allowance, fuel, tolls, and taxes. Additional charges may apply for waiting time or extra stops.',
    },
    {
        question: 'Can I customize pickup and drop-off locations within Hinjewadi?',
        answer: 'Yes, you can specify your preferred pickup and drop-off points within Hinjewadi for a convenient travel experience.',
    },
    {
        question: 'Are safety measures followed for taxi services in Hinjewadi?',
        answer: 'All vehicles are regularly sanitized, and our drivers follow strict safety protocols to ensure your protection.',
    },
    {
        question: 'Is corporate taxi service available in Hinjewadi?',
        answer: 'Yes, Platinum24 Cabs offers customized corporate taxi services in Hinjewadi with priority support and flexible billing options.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Amit Joshi',
        feedback: 'The taxi service in Hinjewadi by Platinum24 Cabs was punctual and comfortable. The driver was very professional.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Priya Kulkarni',
        feedback: 'Booking a taxi in Hinjewadi was quick and hassle-free. Highly recommend Platinum24 Cabs for local travel.',
        rating: 5,
    },
];









































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];









const taxiServiceHinjewadiSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Taxi Service in Hinjewadi Pune",
  "image": "https://www.platinum24cab.com/assets/images/hinjewadi-taxi-service.jpg",
  "description": "Book reliable and affordable taxi service in Hinjewadi, Pune with Platinum24 Cabs. Local, airport, and outstation cabs available 24/7 for corporate and personal travel.",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "350",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/taxi-service-hinjewadi"
  }
};






    return (
        <div>
<Helmet>
  <title>Taxi Service in Hinjewadi Pune | 24/7 Local & Airport Cabs | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Book reliable and affordable taxi service in Hinjewadi, Pune with Platinum24 Cabs. Local, airport, and outstation cabs available 24/7 for corporate and personal travel."
  />
  <meta
    name="keywords"
    content="Taxi Service Hinjewadi Pune, Hinjewadi Cab Service, Taxi Booking in Hinjewadi Pune, Local Cab Hinjewadi, Hinjewadi Taxi Rentals, Affordable Taxi Hinjewadi, Hinjewadi Cab Hire, Hinjewadi Taxi Booking Online, Reliable Cab Service Hinjewadi, Hinjewadi Local Taxi, Hinjewadi Airport Taxi, Hinjewadi Outstation Taxi, Hinjewadi Corporate Cab Service, Hinjewadi Night Taxi Service, Hinjewadi Cab for Events"
  />
  <script type="application/ld+json">
    {JSON.stringify(taxiServiceHinjewadiSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/30.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Taxiserviceinhinjewadipune;